
export default {
  name: 'navbarCategories',
  props: {
    titleNavbar: {
      type: String,
      required: false
    },
    qaName: {
      type: String,
      required: false
    },
    handleClickBack: {
      type: Function,
      required: false
    }
  },
  methods: {
    handleClickPrevPage () {
      if (this.handleClickBack) {
        this.handleClickBack()
      } else {
        this.$router.go(-1)
      }
    }
  }
}
